import { render, staticRenderFns } from "./relationAddress.vue?vue&type=template&id=88492794&"
import script from "./relationAddress.vue?vue&type=script&lang=js&"
export * from "./relationAddress.vue?vue&type=script&lang=js&"
import style0 from "./relationAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports